import { render } from "./OrderFooter.vue?vue&type=template&id=fdf699fc&scoped=true"
import script from "./OrderFooter.vue?vue&type=script&lang=js"
export * from "./OrderFooter.vue?vue&type=script&lang=js"

import "./OrderFooter.vue?vue&type=style&index=0&id=fdf699fc&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf699fc"]])

export default __exports__